<template>
  <div class="hm-menu">
    <li class="logo-wrapper">
      <router-link
        :to="{ name: 'Home' }"
        class="system-name-wrapper flex item-center"
        :class="{ 'is-collapse': isCollapse }"
      >
        <div class="logo-wrapper">
          <img
            src="https://imgcdn.hemiao100.com/hemiaoBase/bf06d026-b271-41cf-8d07-cf2e699c0301.png"
            alt="logo"
          />
        </div>
        <span class="system-name">新零售管理平台</span>
      </router-link>
    </li>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :show-timeout="200"
        :default-active="$route.path"
        :collapse="isCollapse"
        mode="vertical"
        background-color="#fff"
        text-color="#333"
        active-text-color="#E2005D"
      >
        <sidebar-item
          v-for="route in permission_routers"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";

export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters(["permission_routers", "sidebar"]),
    isCollapse() {
      return !this.sidebar.opened;
    }
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.system-name-wrapper {
  padding: 0 20px;
  height: 50px;
  line-height: 56px;
  background: #e50163;
  .system-name {
    // 解决系统名被挤压的问题
    position: fixed;
    left: 65px;
    color: #fff;
    font-size: 14px;
    line-height: 14px;
  }
  .logo-wrapper {
    position: fixed;
    line-height: 1;
    width: 40px;
    img {
      width: 100%;
    }
  }
}

.system-name-wrapper.is-collapse {
  padding: 0;
  overflow: hidden;
  .logo-wrapper {
    padding-left: 3px;
    img {
      width: 30px;
    }
  }
  .system-name {
    display: none;
    height: 0;
    width: 0;
    overflow: hidden;
    visibility: hidden;
  }
}
</style>
